<template>
  <span>
    <template v-if="needSetDrawType">
      <el-button
        type="primary"
        @click="handleDrawType">抽取候选人</el-button>
        <!-- @click="handleDrawType">设置抽签方式</el-button> -->
      <DrawTypeDialog ref="drawTypeDialog" @success="handleSetSuccess" />
    </template>

    <template v-else-if="needOnlineDraw">
      <el-button
        type="primary"
        @click="handleDrawOnline">抽取候选人</el-button>
        <!-- @click="handleDrawOnline">抽签</el-button> -->
      <DrawDialog v-if="showDrawDialog" 
        ref="drawDialog" 
        @onCloseDialog="handleCloseDraw" 
        @onDrawSuccess="handleSuccess" />
    </template>

    <template v-else-if="needOfflineDraw">
      <el-button
        type="primary"
        @click="handleDrawOffline">抽取候选人</el-button>
        <!-- @click="handleDrawOffline">录入抽签结果</el-button> -->
        <DrawInputDialog ref="drawInputDialog" :drawLimit="drawLimit" @success="handleSuccess" />
      </template>
          
      <template v-else-if="checkOnlineDraw">
        <el-button
          type="primary"
          @click="handleDrawOnline">抽取候选人</el-button>
          <!-- @click="handleDrawOnline">查看抽签结果</el-button> -->
        <DrawDialog v-if="showDrawDialog" ref="drawResDialog" @onCloseDialog="handleCloseDraw" />
      </template>

      <template v-else-if="checkOfflineDraw">
        <el-button
          type="primary"
          @click="handleDrawOffline">抽取候选人</el-button>
          <!-- @click="handleDrawOffline">查看抽签结果</el-button> -->
        <DrawInputDialog ref="drawInputDialog" view />
      </template>
      <template v-if="checkOnlineDraw">
        <el-button
          type="primary"
          @click="handleDrawOnlineRecord">抽取结果</el-button>
        <draw-record ref="drawRecordRef" type="hxr"></draw-record>
      </template>
  </span>
</template>

<script>
import DrawStateMixin from '@/mixins/DrawStateMixin'
import DrawDialog from './drawDialog.vue';
import DrawTypeDialog from "./drawTypeDialog.vue";
import DrawInputDialog from './drawInputDialog.vue';
import DrawRecord from "@/components/drawRecord/index.vue";

export default {
  components: {
    DrawDialog, DrawTypeDialog, DrawInputDialog, DrawRecord
  },

  props: {
    drawLimit: {
      type: Number,
      default: 0
    }
  },

  mixins: [DrawStateMixin],

  data() {
    return {
      showDrawDialog: false // 是否显示抽签弹框
    }
  },

  computed: {
    needSetDrawType() {
      return this.drawLotsState !== 0 && this.drawType === 2
    },
    needOnlineDraw() {
      return this.drawLotsState === 1 && this.drawType === 0
    },
    needOfflineDraw() {
      return this.drawLotsState === 1 && this.drawType === 1
    },
    checkOnlineDraw() {
      return this.drawLotsState === 2 && this.drawType === 0
    },
    checkOfflineDraw() {
      return this.drawLotsState === 2 && this.drawType === 1
    }
  },

  created() {
    this.initDrawState()
  },

  methods: {
    handleDrawType() {
      // this.$refs.drawTypeDialog.open()
      this.handleDrawOnline() // 默认使用线上抽签
    },

    handleDrawOnline() {
      this.showDrawDialog = true
      this.$nextTick(() => {
        console.log('this.$refs.drawDialog', this.$refs.drawDialog)

        if (this.$refs.drawDialog) {
          this.$refs.drawDialog.dialogVisible = true
        } else if (this.$refs.drawResDialog) {
          this.$refs.drawResDialog.dialogVisible = true
        }
      })
    },

    handleDrawOffline() {
      this.$refs.drawInputDialog.open()
    },

    handleSetSuccess(data) {
      if (data.drawType === 0) {
        this.handleDrawOnline() // 选择线上抽签则自动打开抽签弹框
      }
      this.initDrawState()
    },

    handleSuccess() {
      this.$refs.drawTypeDialog?.close()
      this.$refs.drawInputDialog?.close()
      this.initDrawState()
      this.$emit('success')
    },

    handleCloseDraw() {
      this.showDrawDialog = false
    },

    update() {
      this.initDrawState()
    },
    handleDrawOnlineRecord() {
      this.$refs.drawRecordRef.dialogVisible = true
    }
  }
}
</script>
